import { Switch } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { InternalAdminUserFragment } from "gql/graphql";
import useInternalAdminUserPreference from "../hooks/use-internal-admin-user-preference";

interface IProps {
  user: InternalAdminUserFragment;
}

const InternalAdminEditUserSms = ({ user }: IProps) => {
  const isSmsDisabled = useMemo(() => !user?.phone, [user?.phone]);

  const { booleanValue: isSms, editUserPreference } =
    useInternalAdminUserPreference({
      user,
      name: "SMS",
    });

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      editUserPreference(e.target.checked === true ? "true" : "false");
    },
    [editUserPreference],
  );

  return (
    <Switch
      size="sm"
      defaultChecked={isSms}
      onChange={onChange}
      isDisabled={isSmsDisabled}
    />
  );
};

export default memo(InternalAdminEditUserSms);
